import { render, staticRenderFns } from "./PaymentBillet.vue?vue&type=template&id=18a1279f"
import script from "./PaymentBillet.vue?vue&type=script&lang=js"
export * from "./PaymentBillet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports